import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { HOME_TILES } from "@/data/conditions";
import { SectionHeading } from "@/components/common/SectionHeading";
import { accent } from "@/lib/ui";

export const ConditionTiles = () => (
  <section className="section relative" aria-labelledby="conditions-heading">
    <div className="container-x">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <SectionHeading id="conditions-heading" eyebrow="What we help with" title="Common spine and pain conditions" intro="Every plan starts with understanding your symptoms and what may be contributing to them." />
        <Link to="/conditions" className="text-link shrink-0" data-testid="conditions-all-link">All conditions <ArrowRight className="h-4 w-4" aria-hidden="true" /></Link>
      </div>
      <ul className="mt-12 grid grid-cols-1 gap-4 min-[420px]:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
        {HOME_TILES.map(({ id, tile, short, icon: Icon }, i) => {
          const a = accent(i);
          return (
            <li key={id}>
              <Link
                to={`/conditions#${id}`}
                data-testid={`condition-tile-${id}`}
                className={`group relative flex h-full flex-col overflow-hidden rounded-3xl bg-white p-6 ring-1 ring-slate-200/80 transition-[box-shadow,transform] duration-300 hover:-translate-y-1.5 ${a.glow}`}
              >
                <span className={`absolute inset-x-0 top-0 h-1.5 ${a.bar}`} aria-hidden="true" />
                <span className={`absolute -right-10 -top-10 h-28 w-28 rounded-full ${a.soft} transition-transform duration-500 group-hover:scale-150`} aria-hidden="true" />
                <span className={`relative flex h-12 w-12 items-center justify-center rounded-2xl shadow-md ${a.icon}`}>
                  <Icon className="h-6 w-6" aria-hidden="true" />
                </span>
                <h3 className="relative mt-5 text-lg font-bold text-brand-ink">{tile}</h3>
                <p className="relative mt-1 flex-1 text-base text-slate-600">{short}</p>
                <span className={`relative mt-4 inline-flex items-center gap-1 text-sm font-semibold ${a.text}`}>
                  Learn more <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  </section>
);
